import React from "react";
/* Import Boostrap */
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import SectionContainer from '../containers/section-container';
//import { Parallax } from 'react-parallax';

const CoverHeader = ({ translate, props }) => {
        var headerSizeClass = props.headerSizeClass !== undefined ? props.headerSizeClass : '';
        const randomImage = props.imageUrl;
        //console.log('CoverHeader renders more than once? '+randomImage);
    return (
        <header id="gtco-header" className={"gtco-cover "+headerSizeClass} >
            <div className="overlay"></div>
            {/* <Parallax bgImage={'../images/'+randomImage} strength={400}> */}
            <div style={{backgroundSize: 'cover', backgroundImage: 'url(../images/'+randomImage+')'}} > 
                <SectionContainer>
                    {props.children}
                </SectionContainer>
            </div>
            {/* </Parallax> */}
        </header> 
    )
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(CoverHeader);



// WEBPACK FOOTER //
// ./src/components/header/cover-header.jsx